import moment from "moment";
import { message } from "antd";
import { getItem } from "../../app/common/util/genericUtils";

export const MAX_REPORT_RANGE_DAYS = 31;

/**
 * Only Customer-role logins are locked to their assigned customer
 * (same as order create/rx). Employee / Corporate / etc. stay free.
 */
export const getLockedReportCustomerId = () => {
  const user = getItem("suprolUser");
  if (!user || user.role !== "Customer") return null;
  if (user.customer != null && user.customer !== "") {
    return user.customer;
  }
  return null;
};

export const REPORT_SUCCESS_CODES = [10, 80];

export const isReportSuccess = (response) =>
  Boolean(
    response &&
      response.data &&
      REPORT_SUCCESS_CODES.includes(response.data.response_code)
  );

export const getDefaultDateRange = () => [moment(), moment()];

export const validateReportDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return "Please select a date range.";
  }
  if (endDate.isBefore(startDate, "day")) {
    return "End date cannot be before start date.";
  }
  if (endDate.isAfter(moment(), "day")) {
    return "End date cannot be in the future.";
  }
  const days = endDate.diff(startDate, "days") + 1;
  if (days > MAX_REPORT_RANGE_DAYS) {
    return `Date range cannot exceed ${MAX_REPORT_RANGE_DAYS} days.`;
  }
  return null;
};

export const buildReportParams = (filters) => {
  const params = {
    start_date: filters.startDate.format("YYYY-MM-DD"),
    end_date: filters.endDate.format("YYYY-MM-DD"),
  };

  if (filters.status) params.status = filters.status;
  if (filters.customerId) params.customer_id = filters.customerId;
  if (filters.branchId) params.branch_id = filters.branchId;
  if (filters.productType) params.product_type = filters.productType;
  if (filters.orderType) params.order_type = filters.orderType;
  if (filters.dlabCustomer !== "") params.dlab_customer = filters.dlabCustomer;
  if (filters.customerCategory) params.customer_category = filters.customerCategory;
  if (filters.primaryBranchId) params.primary_branch_id = filters.primaryBranchId;

  return params;
};

export const getSummaryMetricValue = (metric, valueKey = "count") => {
  if (!metric) return null;
  if (metric[valueKey] != null) return metric[valueKey];
  return metric.count != null ? metric.count : null;
};

export const getSummaryMetricChange = (metric, changeKey) => {
  if (!metric) return null;
  if (metric[changeKey] != null) return metric[changeKey];
  return metric.change != null ? metric.change : null;
};

export const getSummaryChangeClass = (change) => {
  if (change == null || Number.isNaN(Number(change))) return "report-summary-card__change--neutral";
  const value = Number(change);
  if (value > 0) return "report-summary-card__change--up";
  if (value < 0) return "report-summary-card__change--down";
  return "report-summary-card__change--neutral";
};

export const formatChangeLabel = (change) => {
  if (change == null || Number.isNaN(Number(change))) return null;
  const value = Number(change);
  if (value === 0) return "No change";
  const prefix = value > 0 ? "↑" : "↓";
  return `${prefix} ${Math.abs(value)}`;
};

export const reportErrorToast = (error, response) => {
  if (response && response.data && response.data.ui_message) {
    message.error(response.data.ui_message);
    return;
  }
  message.error(error && error.message ? error.message : "Failed to load report");
};
